<div class="row">
    <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
</div>
<h4>Add a New Payment Method</h4>
<div class="mt-5 mb-2 ms-4">
   <p-radioButton class="me-2" name="paymentType" value="creditCard" [(ngModel)]="paymentType" inputId="creditCard" label="Credit Card"></p-radioButton>
   <p-radioButton name="paymentType" value="ach" [(ngModel)]="paymentType" inputId="ach" label="ACH"></p-radioButton>
</div>

<div *ngIf="paymentType === 'creditCard'">
    <app-add-card [hasDefault]="hasDefault" (emitAction)="raiseChildEvent($event)"></app-add-card>
</div>

<div *ngIf="paymentType === 'ach'">
    <app-add-ach (emitAction)="raiseChildEvent($event)"></app-add-ach>
</div>